import { useState } from 'react';

import { toast } from 'react-toastify';

import useConnectWallet from '@/store/wallet/useConnectWallet';

import useListenerTransfer from './useListenerTransfer';

const useAddLiquidity = (successFun?: Function, errorFun?: Function) => {
    const { contractEvm: { router }, address } = useConnectWallet()
    const [addLiquidityLod, setAddLiquidityLod] = useState(false)
    // 获取监听交易完成事件的函数
    const listenerTransferF = useListenerTransfer();
    const addLiquidity = async (
        tokenA: string,
        tokenB: string,
        amountADesired: BigInt,
        amountBDesired: BigInt,
        amountAMin: BigInt,
        amountBMin: BigInt,
        deadline: BigInt,
        toastText?: { success: string, error: string }
    ) => {
        if (router) {
            try {
                setAddLiquidityLod(true); // 开始加载状态
                const { hash } = await router.addLiquidity(
                    tokenA,
                    tokenB,
                    amountADesired,
                    amountBDesired,
                    amountAMin,
                    amountBMin,
                    address,
                    deadline
                );
                // 监听交易完成事件
                const relset = await listenerTransferF(hash);

                if (relset) {
                    // 成功回调
                    toastText && toast.success(toastText.success);
                    successFun && successFun();
                } else {
                    // 失败回调
                    toastText && toast.error(toastText.error);
                    errorFun && errorFun();
                }
            } catch (error) {
                console.error('useAddLiquidity error:', error);
                toastText && toast.error(toastText.error);
            } finally {
                setAddLiquidityLod(false)
            }
        }
    }
    return {
        addLiquidityLod,
        addLiquidity
    }
}

export default useAddLiquidity